import { render, staticRenderFns } from "./videoItem.vue?vue&type=template&id=107b0a5f&scoped=true"
import script from "./videoItem.vue?vue&type=script&lang=js"
export * from "./videoItem.vue?vue&type=script&lang=js"
import style0 from "./videoItem.vue?vue&type=style&index=0&id=107b0a5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107b0a5f",
  null
  
)

export default component.exports